<template>
  <div
    class="siderbar"
    :class="topClass"
  >
    <div class="ptop card">
      <div class="card-header p-1 d-flex  justify-content-between">
        <h3 class="card-title text-uppercase color-blue">
          <b>Media</b>
        </h3>
        <b-form-checkbox
          v-model="frmData.dalet"
          class="checkboxLabel"
          value="1"
          @change="updateDaletState"
        > Gửi tới dalet </b-form-checkbox>
      </div>
      <div class="card-body p-0">
        <div class="mediafile">
          <b-tabs card>
            <b-tab
              title="Audio"
              :active="tabActive == 'audio'"
              @click="activeTab('audio')"
            >
              <div
                v-if="filesContentV2.length > 0"
                class="boxmedia"
              >
                <table class="table table-striped">
                  <tbody>
                    <tr
                      v-for="(item, index) in filesContentV2 "
                      :key="index"
                    >
                      <template v-if="item.isAudio">
                        <td>
                          <span
                            v-if="item.success && item.uploaded"
                            class="icon_file_import"
                            title="Nhúng vào bài"
                            @click.prevent="onUpdateContentEditor(item)"
                          />
                          <span
                            :class="getExtention(item)"
                            title="Xem thử"
                            @click="onPreview(item)"
                          />
                          <div
                            v-if="item.uploaded"
                            class="select-input p-05"
                          >
                            <b-form-checkbox
                              v-model="selectedFileToAddAll"
                              :value="item.id"
                              class="custom-control-danger"
                            />
                          </div>
                        </td>
                        <td width="180">
                          <p class="mb-0 lineText">
                            <strong>{{ item.filename_original }}</strong>
                          </p>
                          <p
                            v-if="item.error"
                            class="text-danger fs_9 font-weight mb-0"
                          >{{ item.error }}</p>
                          <div v-else>
                            <p
                              v-if="item.success || item.uploaded"
                              class="size fs_9 font-weight mb-0"
                            >
                              <span>{{ formatFileSize(item.size) }}</span>
                            </p>
                            <p
                              v-else
                              class="mb-0 size"
                            >{{ formatFileSize(item.progress * item.size / 100) }}/{{ formatFileSize(item.size) }}</p>
                            <b-progress
                              v-if="!item.success && !item.uploaded"
                              max="100"
                              show-value
                              variant="success"
                              class="progress-bar-success"
                            >
                              <b-progress-bar
                                :value="item.progress"
                                :label="`${item.progress}%`"
                                variant="success"
                              />
                            </b-progress>
                          </div>
                        </td>
                        <td
                          class="text-right"
                          width="90"
                        >
                          <b-button
                            v-if="item.uploaded && item.transcribe === 4"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="resolveTranscribeVariant(item.transcribe)"
                            class="btn-icon btn-sm rounded-circle"
                            :title="resolveTranscribeButtonTitle(item.transcribe)"
                            :data-transcrible="item.transcribe"
                            @click.prevent="showTranscribeModal(item)"
                          >
                            <feather-icon icon="TypeIcon" />
                          </b-button>
                          <b-button
                            v-if="item.uploaded && item.transcribe !== 4"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="resolveTranscribeVariant(item.transcribe)"
                            class="btn-icon btn-sm rounded-circle"
                            :title="resolveTranscribeButtonTitle(item.transcribe)"
                            :data-transcrible="item.transcribe"
                            @click.prevent="startTranscribe(item)"
                          >
                            <feather-icon icon="TypeIcon" />
                          </b-button>

                          <b-button
                            v-if="!item.uploaded && item.error && item.isValid"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="btn-icon btn-sm rounded-circle"
                            title="Tải lên"
                            @click.prevent="startUpload(item)"
                          >
                            <feather-icon icon="PlayIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon btn-sm rounded-circle ml-1"
                            title="Xóa"
                            @click.prevent="confirmDeleteFileContent(item)"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab
              title="Image"
              :active="tabActive == 'image'"
              @click="activeTab('image')"
            >
              <div
                v-if="filesContentV2.length > 0"
                class="boxmedia"
              >
                <table class="table table-striped">
                  <tbody>
                    <tr
                      v-for="( item, index ) in filesContentV2 "
                      :key="index"
                    >
                      <template v-if="item.isImage">
                        <td>
                          <span
                            v-if="item.success && item.uploaded"
                            class="icon_file_import"
                            @click.prevent="onUpdateContentEditor(item)"
                          />
                          <span
                            :class="getExtention(item)"
                            @click="onPreview(item)"
                          />
                          <div
                            v-if="item.uploaded"
                            class="select-input p-05"
                          >
                            <b-form-checkbox
                              v-model="selectedFileToAddAll"
                              :value="item.id"
                              class="custom-control-primary"
                            />
                          </div>
                        </td>
                        <td width="180">
                          <p class="mb-0 lineText">
                            <strong>{{ item.filename_original }}</strong>
                          </p>
                          <p
                            v-if="item.error"
                            class="text-danger fs_9 font-weight mb-0"
                          >{{ item.error }}</p>
                          <div v-else>
                            <p
                              v-if="item.success || item.uploaded"
                              class="size fs_9 font-weight mb-0"
                            >
                              <span>{{ formatFileSize(item.size) }}</span>
                            </p>
                            <p
                              v-else
                              class="mb-0 size"
                            >{{ formatFileSize(item.progress * item.size / 100) }}/{{ formatFileSize(item.size) }}</p>
                            <b-progress
                              v-if="!item.success && !item.uploaded"
                              max="100"
                              show-value
                              variant="success"
                              class="progress-bar-success"
                            >
                              <b-progress-bar
                                :value="item.progress"
                                :label="`${item.progress}%`"
                                variant="success"
                              />
                            </b-progress>
                          </div>
                        </td>
                        <td
                          class="text-right"
                          width="90"
                        >
                          <b-button
                            v-if="!item.uploaded && item.error && item.isValid"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="btn-icon btn-sm rounded-circle"
                            @click.prevent="startUpload(item)"
                          >
                            <feather-icon icon="PlayIcon" />
                          </b-button>

                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon btn-sm rounded-circle ml-1"
                            @click.prevent="confirmDeleteFileContent(item)"
                          >
                            <span>
                              <feather-icon icon="XIcon" />
                            </span>
                          </b-button>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab
              title="Video"
              :active="tabActive == 'video'"
              @click="activeTab('video')"
            >
              <div
                v-if="filesContentV2.length > 0"
                class="boxmedia"
              >
                <table class="table table-striped">
                  <tbody>
                    <tr
                      v-for="( item, index ) in filesContentV2 "
                      :key="index"
                    >
                      <template v-if="item.isVideo">
                        <td>
                          <span
                            v-if="item.success && item.uploaded"
                            class="icon_file_import"
                            @click.prevent="onUpdateContentEditor(item)"
                          />
                          <span
                            :class="getExtention(item)"
                            @click="onPreview(item)"
                          />
                          <div
                            v-if="item.uploaded"
                            class="select-input p-05"
                          >
                            <b-form-checkbox
                              v-model="selectedFileToAddAll"
                              :value="item.id"
                              class="custom-control-primary"
                            />
                          </div>
                        </td>
                        <td width="180">
                          <p class="mb-0 lineText">
                            <strong>{{ item.filename_original }}</strong>
                          </p>
                          <p
                            v-if="item.error"
                            class="text-danger fs_9 font-weight mb-0"
                          >{{ item.error }}</p>
                          <div v-else>
                            <p
                              v-if="item.success || item.uploaded"
                              class="size fs_9 font-weight mb-0"
                            >
                              <span>{{ formatFileSize(item.size) }}</span>
                            </p>
                            <p
                              v-else
                              class="mb-0 size"
                            >{{ formatFileSize(item.progress * item.size / 100) }}/{{ formatFileSize(item.size) }}</p>
                            <b-progress
                              v-if="!item.success && !item.uploaded"
                              max="100"
                              show-value
                              variant="success"
                              class="progress-bar-success"
                            >
                              <b-progress-bar
                                :value="item.progress"
                                :label="`${item.progress}%`"
                                variant="success"
                              />
                            </b-progress>
                          </div>
                        </td>
                        <td
                          class="text-right"
                          width="90"
                        >
                          <b-button
                            v-if="!item.uploaded && item.error && item.isValid"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="btn-icon btn-sm rounded-circle"
                            @click.prevent="startUpload(item)"
                          >
                            <feather-icon icon="PlayIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon btn-sm rounded-circle ml-1"
                            @click.prevent="confirmDeleteFileContent(item)"
                          >
                            <span>
                              <feather-icon icon="XIcon" />
                            </span>
                          </b-button>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
          </b-tabs>
          <div class="fileupload d-flex justify-content-between flex-row">
            <fileUploadV2
              ref="uploadV2"
              v-model="filesContentV2"
              class="btn btn-primary btn-sm"
              :upload-url="apiUpload"
              :headers="customHeader"
              :data="customData"
              :accept="acceptMimetypes.join(',')"
              :accept-extensions="acceptExtensions.join(',')"
              :image-extensions="imageExtensions"
              :audio-extensions="audioExtensions"
              :video-extensions="videoExtensions"
              :document-extensions="documentExtensions"
              :image-mimetypes="imageMimetypes"
              :audio-mimetypes="audioMimetypes"
              :video-mimetypes="videoMimetypes"
              :document-mimetypes="documentMimetypes"
              :multiple="true"
              :maximum="10"
              :auto-upload="autoUpload"
              :size="maxUploadSize"
              :timeout="uploadTimeout"
              :chunk-options="chunkOptions"
              input-id="inputUploadSidebarRight"
              @input-file="inputFileV2"
              @input-filter="inputFilterV2"
              @upload-progress="onUploadProgress"
              @upload-success="onUploadSuccess"
              @upload-error="onUploadError"
            >
              <feather-icon icon="UploadIcon" /> Upload từ máy tính
            </fileUploadV2>
            <b-button
              type="button"
              class="start ml-md-1 btn-sm"
              variant="blue2"
              @click="openFileManager"
            >
              <feather-icon icon="ArrowUpCircleIcon" /> Upload từ nguồn khác
            </b-button>
          </div>
          <div class="px-1">
            <b-button
              v-if="selectedFileToAddAll.length"
              class="btn-sm"
              variant="outline-primary"
              @click="addAllToEditor"
            >
              <feather-icon icon="PlusIcon" /> Chèn file
            </b-button>
            <b-button
              v-if="!selectedFileToAddAll.length"
              class="btn-sm"
              variant="outline-primary"
              @click="selecteAllFile"
            >
              <feather-icon icon="PlusIcon" /> Chọn hết
            </b-button>
            <b-button
              v-else
              class="btn-sm ml-1"
              variant="outline-danger"
              @click="clearSelectedAllFile"
            >
              <feather-icon icon="XIcon" /> Bỏ chọn
            </b-button>
          </div>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import {
  ref, computed, watch,
} from '@vue/composition-api';
import {
  BProgress, BProgressBar, BFormCheckbox, BButton, BTab, BTabs,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FileUploadV2 from '@/@core/components/fileupload/FileUpload.vue'
import { getToken } from '@/auth/utils'
import store from '@/store';
import { apiUpload, apiUploadChunk } from '@/libs/initTinymce';
import { showToast } from '@/@core/utils/utils';
import useArticle from '../useArticle';
import useFiles from '../../files/useFiles';

export default {
  components: {
    BButton,
    BProgress,
    BProgressBar,
    FileUploadV2,
    BFormCheckbox,
    BTab,
    BTabs,
  },
  directives: {
    Ripple,
  },
  props: {
    topClass: {
      type: String,
      default: '',
    },
    frmData: {
      type: Object,
      default: null,
    },

  },
  data() {
    return {
      apiUpload,
      apiUploadChunk,
      sync_dalet: 1,
      isUploadAll: false,
      preUploading: false,
      preUploadingMessage: 'Chuẩn bị tải file...',
      preCheckValidMessage: 'Đang kiểm tra thông tin file...',
      preMessage: 'Đang kiểm tra thông tin file...',
      // allowAddAllToEditor: false,
      autoUpload: true,
      dataImage: {},
      timeoutTimer: {},
    }
  },
  computed: {
  },
  watch: {
    filesContentV2(newValue, oldValue) {
      let isAllow = false;
      if (newValue.length) {
        newValue.forEach(item => {
          if (item.uploaded) {
            isAllow = true;
            return true;
          }
        });
      }

      return isAllow;
    },
  },
  setup(props, context) {
    const accessToken = getToken();
    const tabActive = ref('audio');
    const allFiles = ref([]);
    const filesData = ref([]);
    const selectedFileToAddAll = ref([]);
    const allowAddAllToEditor = ref(false);
    const filesContentV2 = computed({
      get() {
        return props.frmData.content_files
      },
      set(newItems) {
        console.log('on set filesContentV2: ', newItems);
        context.emit('update-content-files', newItems)
      },
    });
    const customHeader = ref({
      Authorization: `Bearer ${accessToken}`,
    })
    const customData = ref({
      upload_status: 1,
      category_id: '',
    })

    const {
      fileSettingDatas,
      acceptMimetypes,
      acceptExtensions,
      imageExtensions,
      audioExtensions,
      videoExtensions,
      documentExtensions,
      maxUploadSize,
      uploadTimeout,
      updateFileLog,
      chunkOptions,
      allowSyncDalet,
      createChunk,
    } = useFiles();

    const imageMimetypes = fileSettingDatas.image_mimetypes;
    const audioMimetypes = fileSettingDatas.audio_mimetypes;
    const videoMimetypes = fileSettingDatas.video_mimetypes;
    const documentMimetypes = fileSettingDatas.document_mimetypes;

    const { openFileManager } = useArticle();

    return {
      tabActive,
      openFileManager,
      customHeader,
      filesContentV2,
      filesData,
      allFiles,
      customData,
      acceptMimetypes,
      acceptExtensions,
      maxUploadSize,
      uploadTimeout,
      chunkOptions,
      updateFileLog,
      allowSyncDalet,
      createChunk,
      imageExtensions,
      audioExtensions,
      videoExtensions,
      documentExtensions,
      imageMimetypes,
      audioMimetypes,
      videoMimetypes,
      documentMimetypes,
      allowAddAllToEditor,
      selectedFileToAddAll,
    }
  },

  methods: {
    showAlertPopup(msg) {
      if (msg) {
        this.$swal({
          title: '',
          html: msg,
          allowOutsideClick: true,
          customClass: {
            confirmButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
      }
    },
    deleteUploadFile(file) {
      this.$refs.uploadV2.remove(file);
    },
    validMimetypeOnServer(fileObject, callback) {
      console.log('fileObject,', fileObject);
      // console.log('fileObject.extension,', fileObject.extension);
      if (fileObject.validOnServer) {
        if (typeof callback === 'function') {
          callback(fileObject)
        }
      } else {
        fileObject.validOnServer = true;
        // bypass checkmime
        fileObject.isValid = true;
        // console.log('fileObject.extension, fileObject.mimetype', fileObject.extension, fileObject.mimetype);
        fileObject.isImage = this.$refs.uploadV2.checkIsImage(fileObject.extension, fileObject.mimetype);
        fileObject.isAudio = this.$refs.uploadV2.checkIsAudio(fileObject.extension, fileObject.mimetype);
        fileObject.isVideo = this.$refs.uploadV2.checkIsVideo(fileObject.extension, fileObject.mimetype);
        // console.log('fileObject.isAudio', fileObject.isAudio);
        this.switchTab(fileObject);

        if (typeof callback === 'function') {
          // console.log('fileObject callback', fileObject);
          callback(fileObject)
        }

        // end bypass checkmime

        // const formData = new FormData();
        // formData.append('file', this.createChunk(fileObject.file));
        // formData.append('file_size', fileObject.size);
        // formData.append('filename_original', fileObject.filename_original);
        // fileObject.validOnServer = false;
        // store.dispatch('files/checkMimetype', formData)
        //   .then((res) => {
        //     this.preUploading = false;
        //     fileObject.validOnServer = true;
        //     // console.log('validMimetypeOnServer res: ', res.status, res.message);
        //     if (res.status === 200) {
        //       if (res.data.code === 200) {
        //         fileObject.mimetype = res.data.data.mime_type;
        //         fileObject.isValid = true;
        //         // console.log('fileObject.extension, fileObject.mimetype', fileObject.extension, fileObject.mimetype);
        //         fileObject.isImage = this.$refs.uploadV2.checkIsImage(fileObject.extension, fileObject.mimetype);
        //         fileObject.isAudio = this.$refs.uploadV2.checkIsAudio(fileObject.extension, fileObject.mimetype);
        //         fileObject.isVideo = this.$refs.uploadV2.checkIsVideo(fileObject.extension, fileObject.mimetype);
        //         // console.log('fileObject.isAudio', fileObject.isAudio);
        //         this.switchTab(fileObject);

        //         // check if has duration and over
        //         if (res.data.data.over_duration !== undefined && fileObject.isAudio) {
        //           fileObject.sync_dalet = res.data.data.over_duration ? 0 : 1;
        //           fileObject.over_duration = res.data.data.over_duration;
        //         }

        //         if (typeof callback === 'function') {
        //           // console.log('fileObject callback', fileObject);
        //           callback(fileObject)
        //         }
        //       } else {
        //         // const msg = `Chỉ hỗ trợ định dạng: ${this.acceptExtensions.join(', ')}`;
        //         fileObject.error = res.data.message;
        //         fileObject.isValid = false;
        //         this.showAlertPopup(fileObject.error);
        //         if (!fileObject.duplicated) {
        //           this.deleteUploadFile(fileObject);
        //         }
        //       }
        //     }
        //     if (res.status === 400) {
        //       this.deleteUploadFile(fileObject);
        //     }
        //   })
        //   .catch((err) => {
        //     console.log('err chekmime', err);

        //     fileObject.isValid = false;
        //     fileObject.error = 'Đã có lỗi xảy ra. Vui lòng thử lại sau';
        //     // this.showAlertPopup(fileObject.error);

        //     // auto retry
        //     setTimeout(() => {
        //       this.validMimetypeOnServer(fileObject, callback)
        //     }, 1000);
        //   });
      }
    },
    inputFilterV2(fileObject) {
      // console.log('inputFilterV2 ---> fileObject.error', 'fileObject.duplicated', fileObject.duplicated);
      this.showAlertPopup(fileObject.error);
      if (fileObject.error && !fileObject.duplicated) {
        this.deleteUploadFile(fileObject);
      }
      if (this.autoUpload && fileObject.error === '') {
        this.startUpload(fileObject)
      }
    },
    activeTab(tab) {
      this.tabActive = tab;
      this.clearSelectedAllFile();
    },
    switchTab(fileObject) {
      if (fileObject.isImage) {
        this.tabActive = 'image'
      } else if (fileObject.isVideo) {
        this.tabActive = 'video'
      } else {
        this.tabActive = 'audio'
      }
    },
    inputFileV2(fileObject) {
      // console.log('inputFileV2--> input file --> this.filesContentV2 ', this.filesContentV2);
      this.switchTab(fileObject)
    },
    onUploadProgress(fileObject) {
      // console.log('inputProgressV2 fileObject.progress --> ', fileObject.progress);
    },
    onUploadSuccess(fileObject) {
      // console.log('onUploadSuccess --> ', fileObject);
      this.updateFileLog({
        file_id: fileObject.id,
        file_name: fileObject.filename,
        file_original: fileObject.filename_original,
        source: this.allowSyncDalet(fileObject) ? 3 : 1,
        action: 1,
        code: 1,
        message: 'Upload thành công',
        progress: '100',
      });
      if (this.filesContentV2.length) {
        let isUploadedAll = true;
        this.filesContentV2.forEach(o => {
          if (!o.uploaded) {
            isUploadedAll = false
          }
        });
        if (isUploadedAll) {
          this.$emit('on-uploaded-all');
        }
      }
      if (this.removeFileAfterSuccess) {
        this.deleteUploadFile(fileObject);
      }
    },
    onUploadError(fileObject) {
      // console.log('onUploadError --> ', fileObject);
      this.updateFileLog({
        file_id: fileObject.id,
        file_name: fileObject.filename,
        file_original: fileObject.filename_original,
        source: this.allowSyncDalet(fileObject) ? 3 : 1,
        action: 1,
        code: 2,
        message: `Upload lỗi: ${fileObject.error}`,
        progress: fileObject.progress,
      })
    },
    cancelUpload(item) {
      this.$refs.uploadV2.cancel(item)
      // check if cancal all then show upload all btn
      let isCancelAll = true;
      this.filesContentV2.forEach(o => {
        if (o.active) {
          isCancelAll = false
        }
      });
      if (isCancelAll) {
        this.isUploadAll = false
      }
    },
    startUpload(item) {
      if (item.active || item.uploaded || item.deleted || !item.isValid) {
        return;
      }
      // console.log('if file not start and not uploaded then retry', item);
      if (!item.active && !item.uploaded) {
        console.log('retry file not start and not uploaded', item);
        setTimeout(() => {
          this.startUpload(item);
        }, 5000);
      }

      this.validMimetypeOnServer(item, () => {
        const metas = {
          name: item.name,
          filename: item.filename,
          filename_original: item.filename_original,
          path: item.file_path,
          mimetype: item.mimetype,
          extension: item.extension,
          size: item.size,
          category_id: this.selectedCategory ? this.selectedCategory.id : 0,
          sync_dalet: this.allowSyncDalet(item) ? Number(this.sync_dalet) : 0,
        }
        // console.log('after validMimetypeOnServer --> metas: ', metas);
        this.isUploadAll = true;
        // return console.log('startUpload item metas', item, metas);
        const existFile = this.findFile(item);
        // console.log('existFile', existFile);
        if (existFile === undefined || !existFile.id || existFile.id === undefined) {
          this.preUploading = true;
          this.preMessage = this.preUploadingMessage;
          store.dispatch('files/uploadChunkFile', metas)
            .then((res) => {
              this.preUploading = false;
              if (res.status === 200) {
                item.disabled = false;
                if (res.data.code === 200) {
                  const { fileData } = res.data.data;

                  // set new filename
                  metas.filename = fileData.file;
                  metas.path = fileData.file_path;

                  // console.log('startUpload--> fileData: ', fileData, 'meta: ', metas);

                  item.id = fileData.id;
                  item.filename = fileData.file;
                  item.file_path = fileData.file_path;
                  item.file_local = fileData.file_local;
                  item.file_path = fileData.file_local;

                  store.dispatch('files/setState', { number_uploaded_files: 1 })

                  this.$refs.uploadV2.upload(item, metas)
                } else {
                  item.error = res.data.message
                }
              } else {
                item.error = res.data.message ? res.data.message : res.message;
                if (res.status === undefined) {
                  // // retry upload
                  // console.log('retry upload if server not response');
                  // setTimeout(() => {
                  //   this.startUpload(item)
                  // }, 5000);
                }
              }
            })
            .catch((err) => {
              console.log('on error:', err);
            })
        } else {
          metas.filename = existFile.filename;
          metas.path = existFile.file_path;
          this.$refs.uploadV2.upload(existFile, metas)
        }
      })
    },
    uploadAll() {
      if (this.filesContentV2.length) {
        this.filesContentV2.forEach(item => {
          if (!item.active && !item.deleted && !item.uploaded && item.isValid) {
            this.startUpload(item);
          }
        });
      }
      this.isUploadAll = true
    },
    pauseAll() {
      if (this.filesContentV2.length) {
        this.filesContentV2.forEach(item => {
          if (item.active && !item.uploaded) {
            this.cancelUpload(item);
          }
        });
      }
      this.isUploadAll = false
    },
    findFile(item) {
      return this.filesContentV2.find((o) => o.key === item.key)
    },
    findIndexFile(item) {
      return this.filesContentV2.findIndex((o) => o.key === item.key)
    },
    formatFileSize(bytes, decimals) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    onUpdateContentEditor(item) {
      this.$emit('update-content-editor', item)
    },
    onPreview(item) {
      if (item.success && item.uploaded) {
        this.$emit('preview', item)
      } else {
        showToast('File chưa upload')
      }
    },
    confirmDeleteFileContent(file) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteUploadFile(file)
        }
      })
    },
    getExtention(file) {
      // console.log('file', file)
      const fileExt = file.extension.toLowerCase();
      let cssClass = '';
      if (file.isImage) {
        cssClass = 'icon_img'
      } else if (file.isAudio) {
        cssClass = 'icon_mp3'
      } else if (file.isVideo) {
        cssClass = 'icon_clip'
      } else {
        cssClass = 'icon_docx'
      }
      // if (['docx', 'doc'].includes(fileExt)) {
      //   cssClass = 'icon_docx'
      // } else if (['pdf'].includes(fileExt)) {
      //   cssClass = 'icon_pdf'
      // } else if (this.documentExtensions.includes(fileExt)) {
      //   cssClass = 'icon_xls'
      // } else if (this.videoExtensions.includes(fileExt)) {
      //   cssClass = 'icon_clip'
      // } else if (this.audioExtensions.includes(fileExt)) {
      //   cssClass = 'icon_mp3'
      // } else {
      //   cssClass = 'icon_img'
      // }
      return cssClass;
    },
    updateDaletState(item) {
      this.$emit('update-dalet', this.frmData.dalet)
      this.sync_dalet = this.frmData.dalet
      // console.log('this.sync_dalet', this.sync_dalet);
    },
    showTranscribeModal(item) {
      if (item.success && item.uploaded) {
        // console.log('show-transcribe-modal', item);
        this.$emit('show-transcribe-modal', item)
      } else {
        showToast('File chưa upload')
      }
    },
    updateTranscribeState(item, transcribe) {
      item.transcribe = transcribe;
      this.filesContentV2.find((o, idx) => {
        if (o.id === item.id) {
          o.transcribe = transcribe;
          console.log('updateTranscribeState transcribe', transcribe, item.id);
          this.$set(this.filesContentV2, idx, o)
        }
      });
      this.$emit('update-content-files', this.filesContentV2)
    },
    isFileInActiveTab(file) {
      let ret = false;
      console.log('this.tabActive', this.tabActive);
      switch (this.tabActive) {
        case 'audio':
          ret = file.isAudio;
          break;
        case 'video':
          ret = file.isVideo;
          break;
        default:
          ret = file.isImage;
          break;
      }
      return ret;
    },
    selecteAllFile() {
      this.filesContentV2.find((o, idx) => {
        if (o.uploaded && this.isFileInActiveTab(o)) {
          this.selectedFileToAddAll.push(o.id);
        }
      });
    },
    clearSelectedAllFile() {
      this.selectedFileToAddAll = [];
    },
    addAllToEditor() {
      // console.log('selectedFileToAddAll', this.selectedFileToAddAll);
      if (this.selectedFileToAddAll.length) {
        let tmpArr = [];
        this.selectedFileToAddAll.forEach(id => {
          const file = this.filesContentV2.find((o) => o.id === id);
          if (file) {
            tmpArr.push(file);
          }
        });

        if (tmpArr.length) {
          tmpArr.forEach(item => {
            this.onUpdateContentEditor(item)
          });
        }

        tmpArr = [];
        this.selectedFileToAddAll = [];
      } else {
        showToast('Chưa chọn file');
      }
    },
    resolveTranscribeVariant(transcribe) {
      let variant = 'outline-primary';
      if (transcribe === 4) {
        variant = 'outline-success';
      }
      if (transcribe === 2 || transcribe === 3) {
        variant = 'outline-warning';
      }
      if (transcribe > 4) {
        variant = 'outline-danger';
      }
      return variant
    },
    resolveTranscribeButtonTitle(transcribe) {
      let title = '';
      switch (transcribe) {
        case 2:
        case 3:
          title = 'Đang rải băng';
          break;
        case 4:
          title = 'Xem rải băng';
          break;
        default:
          title = 'Bắt đầu rải băng';
          break;
      }
      return title
    },
    async getFileTranscribe(item) {
      // item.loading = true;
      console.log('getFileTranscribe', {
        file_id: item.id,
      });
      await store.dispatch('speech/getFileTranscribe', {
        file_id: item.id,
      })
        .then(response => {
          // item.loading = false;
          console.log('response', response);
          if (response.data.code === 200) {
            // console.log('response.data.data', response.data.data);
            const { status } = response.data.data;
            item.transcribe = status;
            // console.log('getFileTranscribe item.transcribe', item.transcribe);
          } else {
            item.transcribe = 1;
          }
        })
    },
    async startTranscribe(item) {
      // console.log('startTranscribe item', item);
      await this.getFileTranscribe(item);
      // console.log('after check item:', item);
      if ([4].includes(item.transcribe)) {
        this.showTranscribeModal(item);
      } else if ([2, 3].includes(item.transcribe)) {
        showToast('File đang được xử lý. Vui lòng đợi trong giây lát', { variant: 'warning' });
      } else if ([0, 1, 5, 6].includes(item.transcribe)) {
        const payload = {
          fileData: {
            id: item.id,
            fileName: item.file,
            file: item.file_local,
            access_token: getToken(),
          },
          file: item.file_local,
          provider: 'aimes',
          stage: 'upload_and_convert',
        }
        this.updateTranscribeState(item, 2);
        store.dispatch('speech/startTranscribe', payload)
          .then(response => {
            this.loading = false
            const { code, message, data } = response.data;
            if (code === 200) {
              this.updateTranscribeState(item, data.status);
            } else {
              showToast(message);
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.articleForm {
  .boxmedia {
    max-height: calc(100vh - 345px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .show-publish {
    .boxmedia {
      max-height: calc(100vh - 450px);
    }
  }
}
</style>
